import min from 'lodash/min';
import { getAvailableSlots } from 'redux/modules/slots/selectors';

export const getMinSlotCharge = (state: WtrState) => {
  const availableSlots = getAvailableSlots(state) || [];
  return min(availableSlots.map(slot => slot?.charge?.amount));
};
